import type React from "react";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  /** インラインモード（wrapperなし） */
  inline?: boolean;
  /** アクセシビリティ用ラベル */
  label?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className,
  size = "md",
  inline = false,
  label = "読み込み中",
}) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12",
  };

  const spinner = (
    <output
      className={cn(
        "block animate-spin rounded-full border-2 border-primary border-t-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]",
        sizeClasses[size],
        className,
      )}
      aria-label={label}
    >
      <span className="sr-only">{label}</span>
    </output>
  );

  // インラインモードの場合はwrapperなしで返す
  if (inline) {
    return spinner;
  }

  // 通常モードはwrapper付きで返す
  return <div className="flex items-center justify-center min-h-[200px]">{spinner}</div>;
};

export default LoadingSpinner;
